export default __webpack_public_path__ + "static/media/KYCExample.b888716e.png";